import { ScrollTrigger } from "gsap/ScrollTrigger";
import gsap from "gsap";

// ScrollTriggerを登録
gsap.registerPlugin(ScrollTrigger);

export function header() {
    ScrollTrigger.create({
        start: "top+=77px top", // 77pxスクロールしたらトリガー
        end: "bottom bottom-=100%",
        toggleActions: "play pause resume reset",
        toggleClass: { targets: ".header", className: "header--change" },
    });
}